var exports = {
  "S": "x9245d464--48fb6d--image",
};

module.exports = exports;
